import React, { useEffect, useState } from 'react';
import './Setnewpass.css';
import key from '../../images/key.svg';
import Form from 'react-bootstrap/Form';
import logolight from '../../images/urology-logo-white.svg';
import urologylogotransparent from '../../images/urology-logo-transparent.png';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { MdVisibilityOff, MdVisibility } from "react-icons/md";
import AuthService from '../services/authservice';
import * as Yup from "yup";
import { useFormik } from 'formik';
import { formikSetnewpass } from './validation';
import { toast } from 'react-toastify';
import Button from 'react-bootstrap/Button';

function SetnewpassComponent() {
    const navigate = useNavigate();
    const location = useLocation();
    const [token, setToken] = useState('');
    const [email, setEmail] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
        // Create a URLSearchParams object to parse the query parameters
        const queryParams = new URLSearchParams(location.search);
        // Get the 'otp' and 'email' parameter from the URL
        const token = queryParams.get('token');
        // Update the state with the 'otp' and 'email' values
        setToken(token);
    }, [location.search]);

    // code formik: start
    const formik = useFormik({
        initialValues: {
            newPassword: "",
            retypePassword: "",
        },
        validationSchema: Yup.object({
            newPassword: Yup.string()
                .min(8, "New password must be at least 8 characters")
                .matches(/[A-Z]/, "New password must contain at least one uppercase letter") // At least one uppercase letter
                .matches(/\d/, "New password must contain at least one number") // At least one number
                //   .matches(/[\W_]/, "New password must contain at least one special character") // At least one special character
                .required("New password is required"),
            retypePassword: Yup.string()
                .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
                .required("Confirm password is required"),
        }),
        onSubmit: async (values) => {
            try {
                const postData = {
                    token: token,
                    newPassword: values.newPassword
                };
                const res = await AuthService.resetPassword(postData);
                if (res.data && res.data.status === 'SUCCESS') {
                    toast.success(res.message);
                    navigate("/signin");
                } else {
                    toast.error("Link expired");
                }
            } catch (error) {
                toast.error(error.message);
            }
        },
    });
    // code formik: end

    // Toggle password visibility
    const togglePasswordVisibility = () => setShowPassword((prev) => !prev);
    const toggleConfirmPasswordVisibility = () => setShowConfirmPassword((prev) => !prev);

    return (
        <>
            <Form onSubmit={formik.handleSubmit}>
                <section className='setpass-blk-main'>
                    <div className='setpass-bg-blk'>
                        <div className='logo-top'>
                            <img src={urologylogotransparent} alt='logo'></img>
                        </div>
                    </div>
                    <div className='setpass-text-blk d-flex align-items-center'>
                        <div className='setpass-content'>
                            <div className='keyicon'>
                                <img src={key} alt='key'></img>
                            </div>
                            <div className='setpass-main-text'>
                                <h2>Set New Password</h2>
                                <p>Your new password must be different from previously used passwords.</p>

                                <Form.Group className="mb-3" controlId="formPlaintextPassword">
                                    <Form.Label>Password</Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type={showPassword ? "text" : "password"}
                                            placeholder="Password"
                                            className='form-inputs pe-5'
                                            name="newPassword"
                                            value={formik.values.newPassword}
                                            onChange={(e) => formik.setFieldValue("newPassword", e.target.value)}
                                            onBlur={formik.handleBlur}
                                            isInvalid={formik.touched.newPassword && !!formik.errors.newPassword}
                                        />
                                        <div
                                            onClick={togglePasswordVisibility}
                                            className="password-icon"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "15px",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                zIndex: 10,
                                            }}
                                        >
                                            {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                                        </div>
                                    </div>
                                    {formik.touched.newPassword && formik.errors.newPassword ? (
                                        <div className="text-danger">{formik.errors.newPassword}</div>
                                    ) : null}
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formPlaintextPassword">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <div className="position-relative">
                                        <Form.Control
                                            type={showConfirmPassword ? "text" : "password"}
                                            placeholder="Confirm Password"
                                            className='form-inputs pe-5'
                                            name="retypePassword"
                                            value={formik.values.retypePassword}
                                            onChange={(e) => formik.setFieldValue("retypePassword", e.target.value)}
                                            onBlur={formik.handleBlur}
                                            isInvalid={formik.touched.retypePassword && !!formik.errors.retypePassword}
                                        />
                                        <div
                                            onClick={toggleConfirmPasswordVisibility}
                                            className="password-icon"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                right: "15px",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                zIndex: 10,
                                            }}
                                        >
                                            {showConfirmPassword ? <MdVisibility /> : <MdVisibilityOff />}
                                        </div>
                                    </div>
                                    {formik.touched.retypePassword && formik.errors.retypePassword ? (
                                        <div className="text-danger">{formik.errors.retypePassword}</div>
                                    ) : null}
                                </Form.Group>

                                <Button type="submit" className='dark-btn signin-btn'>
                                    Reset password 1
                                </Button>
                            </div>
                            <Link to="/signin" className='backto-blk'>
                                <FaArrowLeftLong /> Back to log in
                            </Link>
                        </div>
                    </div>
                </section>
            </Form>
        </>
    );
}

export default SetnewpassComponent;
